<template>
  <div class="modal__exit-game">
    <div class="modal__exit-game__header">
      <img src="@/assets/closeBlack.svg" @click.prevent="closeModal">
    </div>
    <img src="@/assets/superliga/training.svg" alt="" class="modal__exit-game__training"  v-if="$config.MODE == 'SUPERLIGA'">
    <h3>{{$t('modal.exitGame.legend_1')}}<br>
      {{$t('modal.exitGame.legend_2')}}</h3>
    <img src="@/assets/inflable-sad.svg" alt="" class="modal__exit-game__fido">
    <button class="modal__exit-game__action" @click.prevent="exitGame">{{$t('modal.exitGame.action')}}</button>
  </div>
</template>
<script>
import persistentData from '@/plugins/persistentData'

export default {
  props: {
    closeModal: Function
  },
  methods: {
    exitGame() {
      this.$store.dispatch('closeModal')
      const dataGame = persistentData.getData(`game-${this.$route.params.id}`, true)
      
      if ( dataGame ) {
        this.$store.dispatch('gameLeave', {
          gameId: dataGame.gameId,
          teamId: dataGame.teamId
        })
        this.$store.dispatch('destroyGameStat')
        this.$store.dispatch('destroyUserIsInGame')
        persistentData.removeData(`game-${this.$route.params.id}`)
        this.$router.push('/home/games')
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.modal__exit-game {
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 400px;
  background: $white;
  height: 208px;
  width: 100%;
  border-radius: $redondeadobig;
  margin: 0 $margin-kilo;
  position: relative;

  @media (min-width: 372px) {
    align-items: flex-start;
  }

  &__header {
    padding: $margin-base;
    align-self: flex-end;
    z-index: 3;
    cursor: pointer;
  }

  h3 {
    padding: 0 $margin-kilo;
    max-width: 240px;
    width: 100%;
    text-align: center;

    @media (min-width: 372px) {
      text-align: left;
    }
  }

  &__fido {
    display: none;

    @media (min-width: 372px) {
      position: absolute;
      right: 40px;
      bottom: 0;
      width: 152px;
      display: block;
    }
  }

  &__action {
    width: 100%;
    background: $lightblue;
    color: $white;
    padding: $margin-base;
    margin-top: $margin-mega;
    text-transform: uppercase;
    font-weight: 700;
    border-radius: 0 0 $redondeadobig $redondeadobig;
    z-index: 2;
    border-top: 1px solid $white;
    position: absolute;
    bottom: -8px;
  }
}
</style>